import { useEffect, useState } from 'react';

const DESKTOP_MIN_WIDTH = 1024;

const isDesktopNow = () =>
  typeof window !== 'undefined' && window.innerWidth >= DESKTOP_MIN_WIDTH;

export function useIsDesktop() {
  const [isDesktop, setIsDesktop] = useState(isDesktopNow);

  useEffect(() => {
    const onResize = () => setIsDesktop(isDesktopNow());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return isDesktop;
}
